(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Upload', Upload);

    Upload.$inject = ['$resource'];

    function Upload ($resource) {
        var resourceUrl =  'api/uploads/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
